/* eslint no-inline-comments: 0 */

const List = () => import( /* webpackChunkName: "group-sensors" */ `./list.vue` );
const Add = () => import( /* webpackChunkName: "group-sensors" */ `./add.vue` );
const Edit = () => import( /* webpackChunkName: "group-sensors" */ `./edit.vue` );
const Settings = () => import( /* webpackChunkName: "group-sensors" */ `./settings.vue` );

export default {
	path: `sensors`,
	children: [
		{
			path: ``,
			name: `list-sensors`,
			component: List,
			meta: {
				title: `Sensors`
			}
		},
		{
			path: `settings`,
			name: `sensor-settings`,
			component: Settings,
			meta: {
				title: `Sensor Settings`
			}
		},
		{
			path: `new`,
			name: `add-sensor`,
			component: Add,
			meta: {
				title: `Add Sensor`
			}
		},
		{
			path: `:uuid`,
			name: `edit-sensor`,
			component: Edit,
			meta: {
				title: `Edit Sensor`
			}
		}
	]
};
